import request from '@/utils/request';

export interface DocItem {
  activityDocId: string;
  activityId: string;
  docId: string;
  docImageUrl: string[];
  aliasName: string;
  docLink: string;
}

/**
 *  获取新手引导
 */
export const getGuide = () => {
  // return Promise.resolve({
  //   data: {
  //     doneAll: 0,
  //     doneMedia: 1,
  //     doneStreaming: 1,
  //     doneWelcome: 1,
  //   },
  // });
  return request.get<{
    doneStreaming: 0 | 1;
    doneWelcome: 0 | 1;
    doneMedia: 0 | 1;
    doneAll: 0 | 1;
  }>(`/api/guide`);
};

/**
 *  设置新手引导
 */
export const putGuide = (data: {
  doneStreaming?: 0 | 1;
  doneWelcome?: 0 | 1;
  doneMedia?: 0 | 1;
  doneAll?: 0 | 1;
}) => {
  return request.put<boolean>(`/api/guide`, data);
};
